import store from '@/store';

const permissionChecker = () => store.getters['dh/hasPermission'] || store.getters['cms/hasPermission'];

const routes = [
    {
        name: 'calendar_events.index',
        path: '/calendar-events',
        components: {
            default: () => import(/* webpackChunkName: "calendar" */ '@/views/calendar/events/Index'),
            ui_v3: () => import(/* webpackChunkName: "calendar" */ '@/views/calendar/v3/Index'),
        },
        meta: {
            loadInModal: true,
            fullview: true,
            actions: true,
            breadcrumbName: 'calendar events',
            title: 'Calendar',
            size: 'large',
            flowStartsWith: 'calendar_events.index',
            allowedRoles: ['CUSTOMER_ADMIN', 'SUPER_ADMIN', 'USER'],
            // requiredAppAccess: ['MIA'],
            product: 'marketing',
            permissionChecker,
        },
    },
    {
        name: 'calendar_events.create',
        path: '/calendar-events/create',
        component: () => {
            return import('@/views/calendar/events/Create');
        },
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'create event',
            title: 'create event',
            flowStartsWith: 'calendar_events.index',
            allowedRoles: ['CUSTOMER_ADMIN', 'SUPER_ADMIN', 'USER'],
            product: 'marketing',
            permissionChecker,
        },
    },
    {
        name: 'calendar_events.detail',
        path: '/calendar-events/detail/:appointment_id/:slot_id',
        component: () => {
            return import('@/views/calendar/events/Detail');
        },
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'event detail',
            title: 'event detail',
            flowStartsWith: 'calendar_events.index',
            allowedRoles: ['CUSTOMER_ADMIN', 'SUPER_ADMIN', 'USER'],
            product: 'marketing',
            size: 'small',
            permissionChecker,
        },
    },
];

export default routes;
